/**
 * modal mixin
 * 这个混合的目的是希望包装调用 modal 更简单。
 * 下面用简单封装一个 MyModal.vue 组件说明用法：
 * ```text/vue
<template>
<Modal ref="modal" v-model="modalVisible" @on-ok="ok" @on-cancel="cancel">
    <template slot="footer">
        <Button :disabled="loading" @click="cancel">取消</Button>
        <Button @click="ok">确定</Button>
    </template>
</Modal>
</template>
<script>
import ModalMixin from "../mixins/modal";
export default {
    mixins: [ModalMixin],
    methods: {
        handleOk(){
            return new Promise(function(resolve, reject){
                // 发送请求等异步操作
            });
        }
    }
}
</script>
```
 * 使用 MyModal.vue ：
```text/html
<MyModal v-model="showModal" @close="onModalClose"/>
```
 * 注意：由于 vue, iview 设计思想的原因，modal 关闭后组件虽然卸载了，但是 modal 实例
 * 是依然存在的，也就是说：首次打开 modal 后输入的数据在下次 modal 打开后数据依然保持
 * 上次交互后的状态。为了避免这种问题，使用 mixins/modal.js 后，需要实现一个 `resetData`
 * 的方法，在方法内部调用 `this.$refs.form.resetFields()` 将组件状态还原到首次打开
 * 前的状态。此方法仅仅对简单数据有效，如果数据是数组、对象，需要手动修改数据。
 */

export default {
  data: function data() {
    return {
      modalVisible: false
    };
  },
  watch: {
    value: function value(val) {
      this.modalVisible = val;
    },
    modalVisible: function modalVisible(val) {
      if (!val && this.value) {
        this.close();
      }
      if (val && typeof this.onLoad === "function") {
        this.onLoad();
      }
    }
  },
  methods: {
    ok: function ok() {
      var _this = this;
      var callback = function callback(result) {
        var modal = _this.$refs.modal;
        if (process.env.NODE_ENV !== "production" && !modal) {
          console.error("请在自定义 modal 模板里面添加 ref=\"modal\"");
        }
        modal.ok();
        _this.close(true, result);
      };
      if (typeof this.handleOk === "function") {
        var promise = this.handleOk();
        if (process.env.NODE_ENV !== "production" && typeof promise.then !== "function") {
          console.error("错误的用法：handleOk 必须返回 promise 对象");
        }
        promise.then(callback, function (e) {
          if (_this.loading === true) {
            _this.loading = false;
            throw e;
          }
        });
      } else {
        if (process.env.NODE_ENV !== "production") {
          console.warn("请在自定义 modal 上实现 handleOk 方法");
        }
        callback();
      }
    },
    cancel: function cancel() {
      this.$refs.modal.cancel();
      this.close(false);
    },
    close: function close() {
      var _this2 = this;
      this.$emit("input", false);
      this.$emit.apply(this, ["close"].concat(Array.prototype.slice.call(arguments)));
      if (typeof this.resetData === "function") {
        this.$nextTick(function () {
          return _this2.resetData();
        });
      }
    }
  }
};